/**
 * Created by MinhQuan on 4/25/2016.
 */

angular.module('common.directive.gonoTree', ['taric.model.nomenclature', 'common.template.footnote.popup', 'common.filter.url', 'common.filter.specialCharacterToHtml', 'common.helper']).component('gonoTree',{
    bindings: {
        data: '=',
        screenType: '@',
        simulationDate: '<',
        tradeDirection: '<',
        commodityCode: '<',
        leafNodeClickable: '<',
        language: '<',
        onSelectCommodityCode: '&',
        onHandleError: '&'
    },
    controller: function (SearchByNomenclatureModel, GoodsNomenclatureTreeModel, $stateParams, $uibModal, $state, CommonHelper, CONSTANTS) {
        var ctrl = this;
        ctrl.gonoTreeConfig = CONSTANTS.gonoTree;


        /**
         * Handler for the event that user selects a gono tree node
         * @param node The selected node
         * @param index The position of the selected node
         */
        ctrl.selectNode = function(node, index) {
            if (node.childItems.length === 0 && !node.item.declarable && node.state.isExpanded) {

                //Load data from database in order to build goods nomenclature child nodes
                if (node.item.type === 'SECTION') {
                    SearchByNomenclatureModel.getSectionChilds(node.item.sid, ctrl.tradeDirection, ctrl.simulationDate, ctrl.language).then(function (result) {
                        GoodsNomenclatureTreeModel.addClassificationAndChildNodesToGonoTree(node, index, result, ctrl.data);
                    }, function (error) {
                        ctrl.handleError(error.data.code, error.data.params);
                    });
                } else if (node.item.type !== 'ClassificationInfo' && node.item.type !== 'ClassificationLink'){
                    SearchByNomenclatureModel.getNomenclatureChilds(node.item.sid, ctrl.tradeDirection, ctrl.simulationDate, ctrl.language).then(function (result) {
                        GoodsNomenclatureTreeModel.addClassificationAndChildNodesToGonoTree(node, index, result, ctrl.data);
                    }, function (error) {
                        ctrl.handleError(error.data.code, error.data.params);
                    });
                }
            } else {

                //Expand or collapse a node in the goods nomenclature tree
                GoodsNomenclatureTreeModel.expandCollapseGonoTreeNode(node, index, ctrl.data);
            }
        };

        ctrl.getTreeNodeClass = function (node) {
            return GoodsNomenclatureTreeModel.getTreeNodeClass(node);
        };

        ctrl.shouldDisplayCode = function(node){
            return node.item.type === 'SECTION' ||
                (node.item.productLineSuffix === "80");
        };


        /**
         * Open footnote popup
         * @param size The size of the popup
         * @param footnoteId Footnote id
         */
        ctrl.openFootnotePopup = function (size, footnoteId){
            $uibModal.open({
                animation: true,
                templateUrl: 'common/popup/footnote/footnote-popup.tmpl.html',
                controller: 'FootnotePopupController as footnotePopupCtrl',
                size: size,
                resolve: {
                    footnote: function (FootnotePopupModel) {
                        return FootnotePopupModel.findFootnote(footnoteId, ctrl.simulationDate);
                    }
                }
            });
        };

        ctrl.shouldDisplayCommodityCodeLink = function (node) {
            return ((ctrl.screenType === 'lookup' && (node.item.type === 'HEADING' || node.item.type === 'NOMENCLATURECODE')) ||
            (ctrl.screenType === 'declarableCommodityCodeLookup' && node.item.declarable));
        };

        ctrl.handleError = function (errorCode, errorParams) {
            ctrl.onHandleError({
                error: {
                    errorCode: errorCode, errorParams: errorParams
                }
            });
        };

        ctrl.selectCommodityCode = function(commodityCode){
            ctrl.onSelectCommodityCode({commodityCode: commodityCode});
        };

        ctrl.viewCommodityCode = function(commodityCode, exportRefundCode){
            var pD = ctrl.tradeDirection;
            if (pD === 'ER') {
                pD = 'E';
            }

            var pCc = CommonHelper.removeSpaceCharacters(commodityCode);
            if (pD === 'E') {
                pCc = pCc.substr(0,8);
            }

            $state.go('taric.measure.mcc', {
                frm: 'taric.nomenclature.sbn',
                cc: pCc,
                sd: CommonHelper.getBookmarkDateString(ctrl.simulationDate),
                d: pD,
                ad: exportRefundCode
            });
        };

        ctrl.isDeclarableCommodityCodeSelected = function(node){
            return node.item.declarable && node.item.code === CommonHelper.removeSpaceCharacters(ctrl.commodityCode);
        };

        ctrl.isLeafNodeClickable = function(){
            return ctrl.leafNodeClickable;
        };

        ctrl.isMatchingCommodityCode = function(code){
            var commodityCode = CommonHelper.removeSpaceCharacters(ctrl.commodityCode);
            if (!code || commodityCode === "" || commodityCode.length < 6){
                return false;
            }
            var codeWithPaddingZeros = ctrl.addPaddingZeros(code);
            return codeWithPaddingZeros.indexOf(commodityCode) === 0;
        };

        ctrl.addPaddingZeros = function(commodityCode){
            if (!commodityCode){
                return commodityCode;
            }
            var result = commodityCode;
            while(result.length < 10){
                result = result + "0";
            }
            return result;
        };

    },
    templateUrl: 'taric/nomenclature/shared/gono-tree.tmpl.html'
});




// WEBPACK FOOTER //
// ./app/taric/nomenclature/shared/gono-tree.directive.js